























import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import ListItem from '@/components/common/ListItem.vue'
import {Service} from '@/store/types'

@Component({
  components: {
    ListItem,
  },
})
export default class SummaryInfoServices extends Vue {
  @Getter('services') public services!: Service[]

  public serviceName(service: string) {
    return service.toLowerCase().split(' ').join('-')
  }
}
